















































// vue
import { Component, Vue } from 'vue-property-decorator'

// componnents
import { PageHeader, ButtonExport, AccordionFilters } from '@/components'
import { TableListLunchControls, FiltersLunchControl as FiltersLunch } from '@/components/dailyControl'

// services
import { LunchControlsService } from '@/services/dailyControl'
import { EmployeeService, RatesLunchService } from '@/services/config'

// utils
import { loading, alerts, getFullNameFormat } from '@/utils'

// models
import { FiltersLunchControl, LunchControlForm, LunchControlModel } from '@/models/dailyControl'
import { RateLunch, EmployeeModel } from '@/models/config'
import { BvModalEvent } from 'bootstrap-vue'

// views
import ModalCreateEditLunchControl from './modalCreateEdit.vue'

const newItem: LunchControlForm = {
  date: '',
  employee_id: null,
  lunch_rate_id: null
}

@Component({
  name: 'LunchControlsIndex',
  components: {
    PageHeader,
    TableListLunchControls,
    ModalCreateEditLunchControl,
    ButtonExport,
    AccordionFilters,
    FiltersLunch
  }
})
export default class LunchControlsIndex extends Vue {
  showModal = false
  lunchControl: LunchControlForm = newItem
  rateLunchs: RateLunch[] = []
  employees: EmployeeModel[] = []
  title = 'Control de Refrigerio'
  actionForm = 'save'
  idItemEdit: number|null = null
  lunchControls: LunchControlModel[] = []

  filters: FiltersLunchControl = {
    dateStart: null,
    dateEnd: null,
    employee: null
  }

  items = [
    {
      text: 'Dashboard',
      to: { name: 'home' }
    },
    {
      text: 'Control de Refrigerio',
      active: true
    }
  ]

  headersExcel = [
    { text: 'Empleado', value: 'employee' },
    { text: 'Fecha', value: 'date' },
    { text: 'Tarifa', value: 'rate' }
  ]

  get itemsExcel () {
    return this.lunchControls.map(item => {
      return {
        date: item.date,
        employee: getFullNameFormat(item.employee),
        rate: item.lunchRate.name
      }
    })
  }

  created () {
    this.getAll()
  }

  async getAll () {
    this.employees = await EmployeeService.getActivated()
    this.rateLunchs = await RatesLunchService.getAllActivated()
  }

  async getAllitems () {
    this.lunchControls = await LunchControlsService.getAll(this.filters)
  }

  hideModal (event: BvModalEvent) {
    if (event.trigger !== 'ok') {
      this.showModal = false
    }
  }

  addNew () {
    this.idItemEdit = null
    this.actionForm = 'save'
    this.lunchControl = newItem
    this.showModal = true
  }

  editItem (item: LunchControlModel) {
    this.lunchControl = {
      date: item.date,
      employee_id: item.employee.id ?? null,
      lunch_rate_id: item.lunch_rate_id ?? null
    }
    if (item.id) {
      this.idItemEdit = Number(item.id)
    }
    this.actionForm = 'update'
    this.showModal = true
  }

  async deleteItem (item: LunchControlModel) {
    const msg = `Seguro que desea eliminar el Control de Refrigerio del Empleado: ${item.employee.name} ${item.employee.last_name}`
    const confirm = await alerts.confirm(msg)
    if (confirm && item.id) {
      loading('show')
      await LunchControlsService.delete(item.id)
      alerts.success()
      this.tableList.getLunchControlsWithPagination()
      loading('hide')
    }
  }

  get tableList (): Vue & { getLunchControlsWithPagination: () => void } {
    return this.$refs.table_list as Vue & { getLunchControlsWithPagination: () => void }
  }

  get itemInit (): LunchControlForm {
      return newItem
  }
}
